var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ly-group',[_vm._l((_vm.dataList),function(x,index){return _c('ly-item',{key:index},[_vm._v(_vm._s(x[_vm.keyw])),_c('Icon',{attrs:{"type":"ios-backspace-outline"},on:{"click":function($event){return _vm.dataList.splice(index, 1)}}})],1)}),_vm._v(" "),_c('Button',{on:{"click":_vm.aaa}},[_vm._v("添加")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a277cad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/alotItem.vue
// module id = null
// module chunks = 